/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ChatMessage } from '../models/ChatMessage';
import { HttpFile } from '../http/http';

export class PaginatedChatMessageList {
    'next'?: string;
    'previous'?: string;
    'results'?: Array<ChatMessage>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "next",
            "baseName": "next",
            "type": "string",
            "format": ""
        },
        {
            "name": "previous",
            "baseName": "previous",
            "type": "string",
            "format": ""
        },
        {
            "name": "results",
            "baseName": "results",
            "type": "Array<ChatMessage>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return PaginatedChatMessageList.attributeTypeMap;
    }

    public constructor() {
    }
}

